import LabelClass from '@arcgis/core/layers/support/LabelClass';
import Font from '@arcgis/core/symbols/Font';
import TextSymbol from '@arcgis/core/symbols/TextSymbol';

export const PriceLabels = new LabelClass({
  labelExpressionInfo: {
    expression: '$feature.price',
  },
  labelPlacement: 'below-center',
  maxScale: 0,
  minScale: 8000,
  symbol: new TextSymbol({
    backgroundColor: 'white',
    color: 'black',
    font: new Font({
      family: 'Noto Sans',
      size: 10,
      weight: 'bold',
    }),
  }),
  where: 'pending = 0',
});
